(function () {
  if (window.__colorThumbGlobalBound) return;
  window.__colorThumbGlobalBound = true;

  function initThumbSwiper(el) {
    if (!window.Swiper) return;
    if (!el || el.classList.contains('is-thumb-initialized')) return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: { enabled: true, momentum: true },
      nested: true,
      threshold: 8,
      simulateTouch: true,
      grabCursor: true,
      watchOverflow: true,
      preventClicks: true,
      preventClicksPropagation: true,
    });

    el.classList.add('is-thumb-initialized');
  }

  // ★後挿入にも効く：document委譲
  document.addEventListener(
    'click',
    function (e) {
      const thumb = e.target.closest('.js-color-thumb');
      if (!thumb) return;

      const itemArea = thumb.closest('.common_item_area');
      if (!itemArea) return;

      // 常に遷移しない（仕様）
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // 子Swiperが未初期化ならここで初期化（後挿入対策）
      const swEl = thumb.closest('.js-colorthumb-swiper');
      if (swEl) initThumbSwiper(swEl);

      // メイン画像/リンク（カード内を探す）
      const mainLink =
        itemArea.querySelector('.main-image-link') ||
        itemArea.querySelector('.common_item_box .zoom-link');

      const mainImg =
        itemArea.querySelector('.common_item_box img') ||
        (mainLink ? mainLink.querySelector('img') : null);

      if (!mainImg || !mainLink) return;

      // 画像差し替え
      const nextSrc = thumb.dataset.mainSrc || '';
      if (nextSrc) {
        // srcsetが残ると見た目が変わらないことがあるので外す
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = nextSrc;
      }

      // メインリンクだけvariantへ同期（メイン画像クリック時に遷移）
      const variantUrl = thumb.dataset.variantUrl || '';
      if (variantUrl) mainLink.href = variantUrl;

      // active切替
      itemArea
        .querySelectorAll('.common_item_color_active')
        .forEach((el) => el.classList.remove('common_item_color_active'));

      const parent = thumb.closest('.common_item_photo');
      if (parent) parent.classList.add('common_item_color_active');
    },
    true
  );
})();